import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer } from "recharts"

const TopCategoriesBar = ({ data }) => (
  <ResponsiveContainer width="100%" height="100%">
    <BarChart 
        data={data}
        margin={{ top: 10, right: 10, left: 10, bottom: 20 }}
    >
      <XAxis
        dataKey="categoryName"
        tick={{ fontSize: 10 }}
        angle={-30}
        textAnchor="end"
      />
      <YAxis />
      <Tooltip />
      {/* ✅ Thinner bars */}
      <Bar dataKey="totalGrievances" fill="#004877" barSize={30} />
    </BarChart>
  </ResponsiveContainer>
)

export default TopCategoriesBar